import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActionCheckBox } from 'src/app/shared/common/ActionCheckBox';
import { CommonDownloadLinkFromS3 } from 'src/app/shared/common/commonDownloadLinkFromS3';
import { constants } from 'src/app/shared/common/contants';
import { FiledownloadComponent } from 'src/app/shared/common/filedownload.component';
import { AttributeMappingConfigService } from 'src/app/shared/services/attribute-mapping-config.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { EtlService } from '../vault-data-migration-etl/etl.service';
import { SnapshotPopupComponent } from './snapshot-popup/snapshot-popup.component';
import { zipFileDownloadComponent } from 'src/app/shared/common/zipFileDownloadComponent';
import { ImportZipComponent } from 'src/app/shared/common/ImportZipDialogData ';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { UserRoutingModule } from '../user-routing/user-routing.module';


@Component({
    selector: 'app-snapshot',
    templateUrl: './snapshot.component.html',
    styleUrls: ['./snapshot.component.scss'],
    standalone: false
})
export class SnapshotComponent implements OnInit {
  gridAPI;
  lastPage;
  currentPage;
  nextPage;
  nextPagePlusOne;
  totalPages;
  gridColumnAPI;
  columnDefs;
  rowData;
  rowClassRules;
  defaultColDef;
  rowSelection;
  paginationPageSize;
  paginationNumberFormatter;
  pageSize;
  components: any;
  overlayNoRowsTemplate;

  getdata: any = [];
  reportData: any;
  userid: any;
  fieldslist: any = {};

  backgroundColorButton = "";
  backgroundColorScreen: string;
  bucketName;
  buttonIdList = []
  constructor(private commonService: CommonService, private snackbar: MatSnackBar, private constants: constants, private loginService: LoginService, private localStorageSettings: LocalStorageSettingsService,private mappingAttributeServices:AttributeMappingConfigService,private spinner: NgxUiLoaderService,
  private etlService: EtlService,private dialog: MatDialog, private userRoutingModule: UserRoutingModule,
	   private reportLinkService:ReportlinksserviceService
  ) {
    //cell rendering in ag-grid
    this.components = {
      downloadReportRef: CommonDownloadLinkFromS3,
      downloadbuttonRenderer: FiledownloadComponent,
      zipdownloadbuttonRenderer: zipFileDownloadComponent,

    }

    //if no rows , this message will display
    this.overlayNoRowsTemplate = this.constants.Norows;
  }

  ngOnInit(): void {
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    console.log(screenPath);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });

   
    let json=["Product Name","Product Family"]
    let json2=[
      { "Product Name": "product1", "Product Family": "Family1" },
      { "Product Name": "product2", "Product Family": "Family2" }
    ]
    console.log(JSON.stringify(json))
    console.log(JSON.stringify(json2))
    this.columnDefs = [
      {
        headerName: 'Snapshot Name',
        headerTooltip: 'Snapshot Name',
        tooltipValueGetter: (params) => 'Snapshot Name : ' + params.value,
        field: 'mappingversionfilename',
        filter: 'agTextColumnFilter',
        width: 230
      },
      {
        headerName: 'Snapshot Version',
        headerTooltip: 'Snapshot Version',
        tooltipValueGetter: (params) => 'Snapshot Version : ' + params.value,
        field: 'mappingversion',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'Download File',
        headerTooltip: 'Download File',
        cellRenderer: "downloadbuttonRenderer",
        field: 'mappingversionpath',
        filter: 'agTextColumnFilter',
        cellRendererParams: {
          values: this.buttonIdList,
          docdownload: this.downloadAttachmentLogs.bind(this),
          //delete: this.deleteIcon.bind(this),
        },
        width: 200
      },
      {
        headerName: 'Export Snapshot',
        headerTooltip: 'Export Snapshot',
        cellRenderer: "zipdownloadbuttonRenderer",
        // field: 'mappingversionpath',
        filter: 'agTextColumnFilter',
        cellRendererParams: {
          zipdownload: this.zipExport.bind(this),
          //delete: this.deleteIcon.bind(this),
        },
        width: 200
      },
      {
        headerName: 'Created By',
        headerTooltip: 'Created By',
        tooltipValueGetter: (params) => 'Created By : ' + params.value,
        field: 'createdby',
        filter: 'agTextColumnFilter',
        width: 200
      },
      {
        headerName: 'Created Date And Time',
        headerTooltip: 'Created Date And Time',
        tooltipValueGetter: (params) => 'Created Date And Time : ' + params.value,
        field: 'createdDateAndTime',
        filter: 'agTextColumnFilter',
        width: 200
      }
    ]
    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    this.getBucketName();
  }

  getBucketName(){
    let dnsId = localStorage.getItem("dnsName");
    this.etlService.retrieveJsuiteProperty(dnsId, "BucketName").subscribe(res => {
      if (res) {
        console.log("******************************************");
        // propertyvalue
        console.log(res);
        this.bucketName=res.propertyvalue
      }
    })
  }
  onPaginationChanged() {
    if (this.gridAPI.api) {
      this.lastPage = this.gridAPI.api.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.api.paginationGetCurrentPage() + 1
      this.nextPage = this.gridAPI.api.paginationGetCurrentPage() + 1 + 1
      this.nextPagePlusOne = this.gridAPI.api.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalPages = this.gridAPI.api.paginationGetTotalPages()
    }
  }

  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {
    this.gridAPI.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pageSize;
    this.gridAPI.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridAPI.api.paginationGoToNextPage();
  }
  onBtExport() {
    this.gridAPI.api.exportDataAsCsv();
  }
  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridAPI.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridAPI.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridAPI.api.paginationGoToLastPage();
  }

  

   onGridReady(params) {

    this.spinner.start();
    this.gridAPI = params;
   this.loadGridData()
  }
  loadGridData(){
    let dnsId = this.localStorageSettings.getSettings("dnsName");;
  this.mappingAttributeServices.retreiveMappingBaselineDetails(dnsId).subscribe(response=>{
      if(response.error == true){
        this.spinner.stop();
        this.gridAPI.api.setGridOption('rowData', [])
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      }else{
        console.log(response);
        this.gridAPI.api.setGridOption('rowData', response)
        this.spinner.stop();
      }
  })
  }

  
 onClickOfCreateBaseline(snapshotName){
  // if (confirm("Creating baseline will generate mapping file with latest version")) {
    this.spinner.start();
    let dnsId = this.localStorageSettings.getSettings("WorkspaceId")
    this.mappingAttributeServices.generateNewMappingFileVersion(dnsId,snapshotName).subscribe(response=>{
      if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      }else{
        console.log(response);
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        let dnsId = this.localStorageSettings.getSettings("dnsName");;
        this.mappingAttributeServices.retreiveMappingBaselineDetails(dnsId).subscribe(response=>{
            if(response.error == true){
              this.spinner.stop();
              this.gridAPI.api.setGridOption('rowData', [])
              this.snackbar.open(response.statusMessage, "OK", {
                duration: 5000,
              });
            }else{
              console.log(response);
              this.gridAPI.api.setGridOption('rowData', response)
              this.spinner.stop();
            }
        })
        this.spinner.stop();
      }
    })
  // }
 }

  openSaveForm() {
    
     let width = '80%';
     var obj={}
     let dialogRef = this.dialog.open(SnapshotPopupComponent, {
       panelClass: 'custom-dialog-container-materialFulfilment',
       width: '60%',
       autoFocus: false,
       data: { edata: obj},
       disableClose: true,
     });
 
    //  subcribe the popup after close
     dialogRef.afterClosed().subscribe(result => {
      //  this.retrieveAssignUsersRoleByDnsId();
 
      if (result) {
       this.onClickOfCreateBaseline(result)
      }
     });
     
   }
 downloadAttachmentLogs(e){
  console.log(e);
  if(!this.bucketName){
    this.getBucketName()
  }
  let s3FilePath = this.bucketName+"/"+e.rowData.mappingversionpath;
  let fileName= e.rowData.mappingversionfilename+".xlsx"
  if (s3FilePath === undefined || s3FilePath === "" || s3FilePath === null) {

    this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

  } else {
    /**
     * modified by Ashwin M
     * 08/01/2025
     * code modified to display waiting message when download is initiated
     */
    this.snackbar.open("Download is underway. Please do not click again the download until it completes the download.", "OK", {duration: 10000});
    let data = {
      s3Path: s3FilePath,
    };
    this.spinner.start();
    this.commonService.downloadFileFromS3(data).subscribe(x => {
      this.spinner.stop()
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should

      console.log(x)
      const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
      const responseData = isJsonBlob(x)
      if (responseData) {
        this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

      } else {
        console.log(x)
        var newBlob = new Blob([x]);
        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        console.log(data)

        var link = document.createElement('a');
        link.href = data;
        link.download = fileName;
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));
        setTimeout(function() {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
        /**
         * modified by Ashwin M
         * 08/01/2025
         * code modified to display file download confirmation
         */
        this.snackbar.open("Download Completed", "OK", {duration: 5000});
      }

    })

    this.spinner.stop();
  }
  
  }
  

 async zipExport(e) {
    console.log(e)
   const snapshotId = e.rowData.mappingevrsionid;
   const importType = "snapshot";
   const tenantId = e.rowData.tenantid;
   
   console.log(tenantId,snapshotId)

    this.snackbar.open("Export Process is InProgress. Please do not click again the Export until it completes the Export.", "OK", { duration: 10000 });
    


    try {
      const blob = await this.commonService.downloadzipFile(snapshotId, tenantId, importType);
      const link = document.createElement('a');
      const timestamp = new Date().getTime();
      link.href = window.URL.createObjectURL(blob);
      link.download = `${snapshotId}_export_${timestamp}.zip`;
      link.click();
      window.URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error('Error downloading JSON:', error);
    }


  }
 
triggerFileInput() {
  const fileInput = document.getElementById('excelFileInput') as HTMLInputElement;
  if (fileInput) {
    fileInput.click(); // Opens file dialog
  }
}
 statevaluechange={"fileName":"","fileData":""}

onFileSelected(event: Event) {
  const input = event.target as HTMLInputElement;
  if (!input.files || input.files.length === 0) return;

  const file = input.files[0];
  console.log('Selected file:', file);

  // ✅ Validate file type
  if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
    this.snackbar.open('Please select a valid Excel file (.xlsx or .xls)', 'OK', { duration: 5000 });
    input.value = ''; // Reset input
    return;
  }

  // ✅ Ask for confirmation before upload
  if (!confirm('Do you want to create a snapshot?')) {
    return; // User cancelled
  }

  // ✅ Set fileName in state (metadata)
  this.statevaluechange.fileName = file.name;

  this.spinner.start();
  let dnsId = this.localStorageSettings.getSettings("WorkspaceId");

  // ✅ Upload file via service, pass the original File object
  this.commonService.uploadMappingFile(this.statevaluechange, dnsId, file).subscribe(
    (response) => {
      console.log(response);
      this.spinner.stop();

      if (response.error === true) {
        this.snackbar.open(response.statusMessage, 'OK', { duration: 5000 });
      } else {
        this.snackbar.open(response.statusMessage, 'OK', { duration: 5000 });
        this.loadGridData()
      }

      //this.ngOnInit(); 
    },
    (error) => {
      this.spinner.stop();
      console.error('Error during upload:', error);
      this.snackbar.open('File upload failed.', 'OK', { duration: 5000 });
    }
    
  );
  input.value = '';
}

importData() {
   
      console.log("<--- Inside upload Group Template --->")
      let width = "85%";
  let dialogRef = this.dialog.open(ImportZipComponent, {
        maxWidth: "70vw",
        height: "50%",
        width: width,
      data: { "tablename": ""},
        disableClose: true,
      });
    
      dialogRef.afterClosed().subscribe((result) => {
        console.log(result);
    
        //this.reportCreationData = result;
    
        //this.vaultObjectService.retrieveobjectgroup();
      });
    
    
  }



}
